import React from 'react';
import { GlobalStyles } from '@mui/material';

// Motion + colour utilities for the redesign. Everything is plain CSS (no animation library) and is switched off for
// users who prefer reduced motion.
export const ACCENTS = {
  indigo: '#6366f1', violet: '#8b5cf6', sky: '#0ea5e9', emerald: '#10b981', amber: '#f59e0b', rose: '#f43f5e', teal: '#14b8a6',
};
export const GRADIENTS = {
  brand: 'var(--g-brand)', hero: 'var(--g-hero)', sky: 'var(--g-sky)', emerald: 'var(--g-emerald)', amber: 'var(--g-amber)', violet: 'var(--g-violet)',
};

export const AppGlobalStyles = () => (
  <GlobalStyles styles={(theme) => ({
    '@keyframes fadeUp': { from: { opacity: 0, transform: 'translateY(16px)' }, to: { opacity: 1, transform: 'none' } },
    '@keyframes fadeIn': { from: { opacity: 0 }, to: { opacity: 1 } },
    '@keyframes popIn': { '0%': { opacity: 0, transform: 'scale(0.94) translateY(8px)' }, '60%': { transform: 'scale(1.01)' }, '100%': { opacity: 1, transform: 'none' } },
    '@keyframes floatY': { '0%,100%': { transform: 'translateY(0)' }, '50%': { transform: 'translateY(-10px)' } },
    '@keyframes blobMove': { '0%,100%': { transform: 'translate(0,0) scale(1)' }, '33%': { transform: 'translate(30px,-20px) scale(1.08)' }, '66%': { transform: 'translate(-20px,20px) scale(0.95)' } },
    '@keyframes gradientShift': { '0%': { backgroundPosition: '0% 50%' }, '50%': { backgroundPosition: '100% 50%' }, '100%': { backgroundPosition: '0% 50%' } },
    '@keyframes shimmerSweep': { '0%': { transform: 'translateX(-120%) skewX(-18deg)' }, '60%,100%': { transform: 'translateX(220%) skewX(-18deg)' } },
    '@keyframes marchAnts': { to: { backgroundPosition: '24px 0, -24px 100%, 0 -24px, 100% 24px' } },
    '@keyframes pulseRing': { '0%': { boxShadow: '0 0 0 0 rgb(var(--c-primary-rgb) / 0.45)' }, '70%': { boxShadow: '0 0 0 14px rgb(var(--c-primary-rgb) / 0)' }, '100%': { boxShadow: '0 0 0 0 rgb(var(--c-primary-rgb) / 0)' } },
    '@keyframes bounceUp': { '0%,100%': { transform: 'translateY(0)' }, '40%': { transform: 'translateY(-8px)' }, '60%': { transform: 'translateY(-3px)' } },
    '@keyframes dots': { '0%,20%': { content: '"."' }, '40%': { content: '".."' }, '60%,100%': { content: '"..."' } },
    '@keyframes spinSlow': { to: { transform: 'rotate(360deg)' } },

    '.anim-fade-up': { animation: 'fadeUp .55s cubic-bezier(.22,.8,.3,1) both' },
    '.anim-pop': { animation: 'popIn .6s cubic-bezier(.22,.8,.3,1) both' },
    '.page-enter': { animation: 'fadeUp .45s cubic-bezier(.22,.8,.3,1) both' },
    '.float': { animation: 'floatY 5s ease-in-out infinite' },
    '.analyzing-dots::after': { content: '"..."', animation: 'dots 1.4s steps(1) infinite' },

    // stagger the direct children of grids / lists a little for a "cards arriving" feel
    ...Object.fromEntries(Array.from({ length: 10 }, (_, i) => [`.stagger > *:nth-of-type(${i + 1})`, { animationDelay: `${i * 70}ms` }])),
    '.stagger > *': { animation: 'fadeUp .55s cubic-bezier(.22,.8,.3,1) both' },

    // every Card/outlined Paper in the results eases in and lifts on hover
    '.MuiCard-root, .MuiPaper-outlined': { transition: 'transform .25s ease, box-shadow .25s ease, border-color .25s ease' },
    '.MuiCard-root:hover': { transform: 'translateY(-3px)', boxShadow: '0 10px 28px rgb(var(--c-primary-rgb) / 0.16)', borderColor: theme.palette.primary.light },
    '.MuiTableRow-hover': { transition: 'background-color .2s ease, box-shadow .2s ease' },
    '.MuiTableRow-hover:hover': { boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}` },

    '@media (prefers-reduced-motion: reduce)': {
      '*, *::before, *::after': { animationDuration: '.001ms !important', animationIterationCount: '1 !important', animationDelay: '0ms !important', transitionDuration: '.001ms !important', scrollBehavior: 'auto !important' },
    },
  })} />
);
